/**
 * WhatsappStatus
 * @author gabrielbgil
 */
import {$, ID, Resource, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import WhatsappStatusSchema from '@/schema/WhatsappStatus.schema'

export default class WhatsappStatus extends Resource {
  static readonly PENDENTE = 1
  static readonly APROVADO = 2
  static readonly REPROVADO = 3

  readonly $name: string = 'WhatsappStatus'

  readonly $endpoint: string = '/user/config-whatsapp/status{/id}'

  get $schema() {
    return WhatsappStatusSchema(this)
  }

  get $id() {
    return this.idWhatsappStatusPk
  }
  set $id(val: ID) {
    this.idWhatsappStatusPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  idWhatsappStatusPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  ativo: boolean = false
}
